import styled from 'styled-components';
import AppCSS from '../../../utils/styled';
import { Form } from 'formik';
import { DefaultModalComponents } from '../../../components/ProjectModal/utils';
import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/icon-arrow-down.svg';
import Checkbox from '@mui/material/Checkbox';
import { SMALL_BUTTON_WIDTH } from '../../../utils/styled/dimensions';

export const Components = {
  ...DefaultModalComponents,
  FormButtonsContainer: styled.div`
    padding-top: 28px;
    padding-bottom: 28px;
    width: 100%;
    grid-gap: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  PrimaryButton: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    min-width: max-content;
    padding: 10px 16px;
    ${AppCSS.fonts.h5};
    color: ${AppCSS.colors.white};
    background-color: ${AppCSS.colors.blues.dark};
    border: none;
    cursor: pointer;
  `,
  TertiaryButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)``,

  Form: styled(Form)`
    width: 100%;
  `,

  FieldsWrapper: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 3px 1fr;
    grid-column-gap: 8px;
  `,
  FieldsContent: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldStartAdornment: styled.div<{ variant: 'minimal' | 'readyToPlay' | 'additional' }>`
    min-height: 24px;
    height: auto;
    width: 3px;
    ${AppCSS.radiuses.small};
    background-color: ${({ variant }) => {
      switch (variant) {
        case 'minimal':
          return AppCSS.colors.red;
        case 'readyToPlay':
          return AppCSS.colors.orange;
        case 'additional':
          return AppCSS.colors.greys.darker;
      }
    }};
  `,

  FieldWrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldLabel: styled.span<{ destructive?: boolean }>`
    ${AppCSS.fonts.label12Bold};
    color: ${(p) => (p.destructive ? AppCSS.colors.red : AppCSS.colors.blues.veryDark)};
  `,
  FieldBasic: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,

  LengthInputsWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,

  FieldWrapperWithInsight: styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 12px;
    overflow: hidden;
    white-space: nowrap;
  `,
  PrefixedTextFieldWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
  `,

  PrefixLabel: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
    width: 17%;
  `,

  UploadButton: styled.label`
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${AppCSS.colors.white};
    padding: 12px 24px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.black};
    cursor: pointer;
  `,

  ClearButton: styled.div`
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${AppCSS.colors.white};
    padding: 12px 24px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.red};
    cursor: pointer;
  `,

  ModalContentContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 8px;
    padding: 16px !important;
  `,
  TableWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    ${AppCSS.boxShadows.block};
  `,
  Picker: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    background-color: transparent;
    overflow: hidden;
    width: 100%;
    padding: 12px;
  `,
  PickerIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  PickerLabel: styled.span`
    flex: 1;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  PickerIcon: styled(ArrowDownIcon)`
    height: 16px;
    width: 16px;
  `,
  NotSetLabel: styled.span`
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.black};
    flex: 1;
  `,

  CheckboxFieldWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 12px;
    margin: 12px 0;
  `,

  Checkbox: styled(Checkbox)<{ destructive?: boolean }>`
    &.Mui-checked {
      color: ${(p) => (p.destructive ? AppCSS.colors.red : AppCSS.colors.blues.dark)} !important;
    }
    color: ${AppCSS.colors.blues.veryLight};
    width: 20px;
    height: 20px;
  `,
  CheckboxLabel: styled.span<{ destructive?: boolean }>`
    width: ${SMALL_BUTTON_WIDTH}px;
    min-width: ${SMALL_BUTTON_WIDTH}px;
    ${AppCSS.fonts.label12Bold};
    color: ${(p) => (p.destructive ? AppCSS.colors.red : AppCSS.colors.blues.veryDark)};
  `,
  CheckboxDescription: styled.span<{ destructive?: boolean }>`
    min-width: 40%;
    width: 40%;
    flex-grow: 2;
    ${AppCSS.fonts.paragraph12Regular};
    color: ${(p) => (p.destructive ? AppCSS.colors.red : AppCSS.colors.blues.veryDark)};
  `,

  FiltersWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    margin: 12px 0;
  `,
  FiltersNameWrapper: styled.div`
    width: 150px;
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  BasicText: styled.span<{ align: 'left' | 'right' }>`
    width: 100%;
    text-align: ${({ align }) => {
      switch (align) {
        case 'left':
          return 'start';
        case 'right':
          return 'end';
      }
    }};
    ${AppCSS.fonts.paragraph12Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,
};
